namespace $.$$ {
	
	$mol_style_define( $shm_ba_user_settings, {
		
		gap: $mol_gap.space,
		flex: {
			wrap: 'wrap',
		},

		Agent_settings: {
			gap: $mol_gap.space,
			flex: {
				basis: '100%',
			},
		},

		Agent_enabled: {
			align: {
				self: 'flex-end',
			},
		},

		Wordstat_enabled: {
			align: {
				self: 'flex-end',
			},
		},
		
	} )
	
}
